<div class="withdraw-balance__content">
  <form [formGroup]="form">
    <div *ngIf="getModalStep === 1" class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <button class="btn btn-link f-color-dark f-size-14 pl-0">
            გადახდა
          </button>
        </h5>
        <button type="button" class="close" (click)="closeModal()">
          <img src="/assets/images/close.svg" alt="X" />
        </button>
      </div>
      <div class="modal-body">
        <h1 class="f-size-24 fw-bold mb-4">აირჩიეთ გატანის ტიპი</h1>
        <div
          class="d-flex flex-md-row flex-column align-items-start align-items-lg-center justify-content-between"
        >
          <div class="d-flex align-items-center form-group">
            <div class="circle-45 border mr-3">
              <img src="/assets/images/credit-card-blue.svg" />
            </div>
            <div>
              <h4 class="f-size-16 fw-medium">
                {{ user.account_number ? "ანგარიში" : "ბალანსი" }}
              </h4>
              <p class="mb-0 f-size-14">
                {{ user.account_number }}
                <span class="f-color-success-green">{{ user.balance }}₾</span>
              </p>
            </div>
          </div>
          <app-text-input
            formControlName="price"
            placeholder="მიუთითეთ თანხა"
            [floatingPlaceholder]="true"
          ></app-text-input>
        </div>

        <div class="w-100 d-flex justify-content-end mt-4">
          <button
            type="button"
            class="btn btn-primary bg-vibrant-blue col-md-3 fw-medium py-3 col-sm-4 col-8"
            data-dismiss="modal"
            (click)="withdrawMoney()"
            [disabled]="disableWithdrawButton"
          >
            თანხის გატანა
          </button>
        </div>
      </div>
      <!-- <button type="button" class="btn btn-primary" (click)="auctionDelete(isBalanceModalOpen)">წაშლა</button> -->
    </div>
    <div *ngIf="getModalStep === 2" class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <button
            class="btn btn-link pl-0 f-color-dark f-size-14 withdraw-balance__content__btn-left-arrow"
            (click)="modalFirstStep()"
          >
            უკან
          </button>
        </h5>
        <button type="button" class="close" (click)="closeModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body text-center">
        <h1 class="f-size-30 fw-bold mb-3">SMS-კოდი გამოგზავნილია</h1>
        <p class="f-size-16 fw-regular f-color-balance-modal-text mb-4">
          ჩვენ გამოგიგზავნეთ SMS დასტურის კოდი ნომერზე
          <span class="fw-medium">{{ getUserPhoneNumber }}</span
          >, რომელიც მითითებული გაქვთ თქვენი ანგარიშის ძირითად ნომრად
        </p>

        <p class="f-size-14">
          შეიყვანე 4-ნიშნა კოდი, რომელიც მიიღე ნომერზე {{ getUserPhoneNumber }};
        </p>
        <app-text-input
          formControlName="phone_code"
          placeholder="XXXX შეიყვანეთ კოდი"
          class="mx-auto col-8"
          [floatingPlaceholder]="true"
        >
        </app-text-input>
        <p class="f-size-14">
          არ მიგიღიათ კოდი?
          <span *ngIf="getTimer" class="f-color-balance-modal-text"
            >სცადე {{ getTimer }} წამში</span
          >
          <button
            *ngIf="!getTimer"
            class="btn btn-link f-size-14 f-color-balance-modal-text fw-medium p-0"
            (click)="sendSms()"
          >
            სცადე თავიდან
          </button>
          ან
          <a class="fw-medium">დაგვიკავშირდით</a>
        </p>
      </div>
    </div>
    <div *ngIf="getModalStep === 3" class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <button
            class="btn btn-link pl-0 f-color-dark f-size-14 withdraw-balance__content__btn-left-arrow"
            (click)="modalFirstStep()"
          >
            უკან
          </button>
        </h5>
        <button type="button" class="close" (click)="closeModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div
          *ngIf="getTransactionSuccess"
          class="d-flex align-items-center flex-column pt-4 text-center"
        >
          <img class="mb-3" src="/assets/images/success_1.svg" />

          <h2 class="f-size-22 fw-bold f-color-black mb-3">
            მოთხოვნა წარმატებით გაიგზავნა
          </h2>

          <p class="f-color-action-text mb-4">
            თქვენ დაგიკავშირდებათ ჩვენი წარმომადგენელი
          </p>

          <button
            type="button"
            class="btn btn-primary bg-vibrant-blue col-md-4 col-8 fw-medium py-3 mb-5"
            data-dismiss="modal"
            (click)="closeModal()"
          >
            დახურვა
          </button>
        </div>
        <div
          *ngIf="!getTransactionSuccess"
          class="d-flex align-items-center flex-column pt-4 text-center"
        >
          <img class="mb-3" src="/assets/images/red-error.svg" />

          <h2 class="f-size-22 fw-bold f-color-black mb-3">
            ტრანზაქცია ვერ განხორციელდა
          </h2>

          <p class="f-color-action-text mb-4">
            აქ ჩაიწერება მიზეზი რის გამოც ვერ გადაირიცხა
          </p>

          <button
            type="button"
            class="btn btn-primary bg-vibrant-blue col-md-4 col-8 fw-medium py-3 mb-5"
            data-dismiss="modal"
            (click)="modalFirstStep()"
          >
            სცადეთ თავიდან
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="withdraw-balance__bg" (click)="closeModal()"></div>
